<template>
  <div class="has-partner-component">
    <div class="column is-8-desktop is-10-tablet is-full-mobile is-offset-2-desktop is-offset-1-tablet is-offset-0-mobile">
      <div class="columns">
        <div class="column is-full">
          <p class="is-size-1 is-size-2-tablet is-size-3-mobile has-text-centered has-text-grey-dark dm-sans">
            Você pertence a alguma rede ou associação parceira?
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column is-full">
          <div class="buttons is-flex is-justify-content-center is-full">
            <button
                class="button is-grey is-size-3 is-size-4-tablet is-size-5-mobile has-text-weight-bold mx-4 mx-2-mobile partner-btn"
                @click.prevent="showPartners = true"
            >
              Sim
            </button>
            <button
                class="button is-grey is-size-3 is-size-4-tablet is-size-5-mobile has-text-weight-bold mx-4 mx-2-mobile partner-btn"
                @click.prevent="selectNoPartner()"
            >
              Não
            </button>
          </div>
        </div>
      </div>
      <div class="choose-partners" v-if="showPartners">
        <div class="columns mt-4">
          <div class="column is-full">
            <p class="is-size-1 is-size-2-tablet is-size-3-mobile has-text-centered has-text-grey-dark dm-sans">
              Qual?
            </p>
          </div>
        </div>
        <div class="columns mt-4">
          <div class="column is-full is-flex is-justify-content-center is-align-content-center">
            <div class="select is-large is-primary is-one-quarter-desktop is-half-tablet is-full-mobile">
              <select class="has-text-centered" v-model="formData.partner.data">
                <option disabled selected>Selecionar</option>
                <option :value="partner" v-for="(partner, index) in partners" :key="index">
                  {{ partner.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="column is-12 pt-6" v-if="formData.partner.data && formData.partner.data.id">
      <next-button
          @nextTab="$emit('nextTab')"
          position="right"
          sizeClass="is-one-third is-fullwidth-mobile"
      ></next-button>
    </div>
  </div>
</template>

<script>

import partners from '@/apis/partners'
import NextButton from './NextButton'

export default {

  name: 'partners',

  data() {
    return {
      partners: [],
      showPartners: false
    }
  },

  components: {
    NextButton
  },

  props: {
    formData: {
      required: true,
      type: Object
    }
  },

  async mounted() {
    this.partners = await partners.get()

    for (const partner of this.partners) {
      let networkId = this.formData.company.data.network_id;
      let externalId = partner.external_id;
      console.log(networkId)
      console.log(externalId)
      if (networkId && externalId && (externalId == networkId)) {
        this.formData.partner.data = partner
        this.$emit('nextTab')
        break
      }
    }
  },

  methods: {
    selectNoPartner() {
      this.formData.partner.data = {}
      this.$emit('nextTab')
    }
  }

}

</script>

<style lang="scss" scoped>
.has-partner-component {
  overflow-x: hidden;
  width: 100%;
  
  .partner-btn {
    min-width: 120px;
  }
  
  select {
    max-width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .has-partner-component {
    .is-size-3-mobile {
      font-size: 1.5rem !important;
    }
    
    .is-size-5-mobile {
      font-size: 1rem !important;
    }
    
    .mx-2-mobile {
      margin-left: 0.5rem !important;
      margin-right: 0.5rem !important;
    }
    
    .partner-btn {
      min-width: 80px;
      padding: 0.5rem 1rem;
    }
    
    .select {
      width: 100%;
      max-width: 90%;
      
      select {
        width: 100%;
        font-size: 1rem;
      }
    }
    
    .is-large {
      font-size: 1rem;
    }
    
    .pt-6 {
      padding-top: 1rem !important;
    }
  }
}

@media screen and (max-width: 480px) {
  .has-partner-component {
    .partner-btn {
      min-width: 60px;
      padding: 0.5rem;
    }
  }
}
</style>
